var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-2"},_vm._l((_vm.slots),function(num){return _c('v-row',{key:num,class:_vm.createClass(num),attrs:{"justify":"center"}},[_c('v-col',{staticClass:"px-1 ma-0",attrs:{"cols":"12"}},[_vm._t(num)],2)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }